<template>
  <div class="fanshui-rule-page">
    <div class="page-top">
      <img
        class="back-btn"
        src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png"
        alt="返回"
        @click="$router.back()"
      />
      返水规则
    </div>
    <div class="page-top-placeholder"></div>

    <div class="rule-card">
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          class="tab-item"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
        >
          {{ tab.label }}
        </div>
      </div>

      <div class="table-wrap">
        <table class="rule-table">
          <thead>
            <tr>
              <th>游戏</th>
              <th>返水比例</th>
              <th>投注返水</th>
              <th>佣金返水</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in gameList" :key="index" :class="{ stripe: index % 2 === 1 }">
              <td>{{ item.name }}</td>
              <td>{{ item.rate }}</td>
              <td>{{ item.betRebate }}</td>
              <td>{{ item.commissionRebate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="rule-notes">
        <p>1. 每日投注返水派送于次日、下周一、下个月一号（早上8点），都可领取。</p>
        <p>2. 同IP多账号、不同账号对刷等违规投注，不可参与本活动。</p>
        <p>3. 所得返水需一倍流水。</p>
      </div>

      <div class="rule-footer">
        <span class="agent-link" @click="$router.push('/agentCenter')">代理中心 &gt;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fanshuiRule',
  data() {
    return {
      activeTab: 'daily',
      tabs: [
        { key: 'daily', label: '每日返水' },
        { key: 'weekly', label: '每周返水' },
        { key: 'monthly', label: '每月返水' }
      ],
      gameList: [
        { name: 'GO扑克', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '电子', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '捕鱼', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '棋牌', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '彩票', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '电竞', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '真人', rate: '0.6%', betRebate: '0', commissionRebate: '0' },
        { name: '体育', rate: '0.6%', betRebate: '0', commissionRebate: '0' }
      ]
    };
  }
};
</script>

<style scoped>
.fanshui-rule-page {
  min-height: 100vh;
  background: #eef3fb;
  box-sizing: border-box;
  padding-bottom: 24px;
}

.page-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background: url(/img/counter/top-bg.webp) no-repeat #084ccb;
  background-size: cover;
  z-index: 1000;
}

.back-btn {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.page-top-placeholder {
  height: 46px;
}

.rule-card {
  margin: 12px;
  background: #f7f9fd;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(47, 94, 180, 0.08);
  overflow: hidden;
  padding-bottom: 12px;
}

.tabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 14px 10px 0;
  background: #f7f9fd;
}

.tab-item {
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 15px;
  color: #666;
  padding-bottom: 10px;
  cursor: pointer;
}

.tab-item.active {
  color: #2f6bdc;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 28px;
  height: 3px;
  margin-left: -14px;
  border-radius: 2px;
  background: #2f6bdc;
}

.table-wrap {
  margin: 12px 10px 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #d9e6fb;
}

.rule-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
  text-align: center;
}

.rule-table thead tr {
  background: linear-gradient(180deg, #e8f1ff 0%, #d7e7ff 100%);
  color: #335b9a;
}

.rule-table th,
.rule-table td {
  padding: 11px 4px;
  border-bottom: 1px solid #e6eefb;
}

.rule-table th {
  font-weight: 600;
}

.rule-table tbody tr {
  background: #fff;
  color: #444;
}

.rule-table tbody tr.stripe {
  background: #f3f8ff;
}

.rule-table tbody tr:last-child td {
  border-bottom: none;
}

.rule-notes {
  padding: 14px 14px 6px;
  color: #555;
  font-size: 12px;
  line-height: 1.7;
}

.rule-notes p {
  margin: 0 0 6px;
}

.rule-footer {
  display: flex;
  justify-content: flex-end;
  padding: 4px 14px 8px;
}

.agent-link {
  color: #2f6bdc;
  font-size: 13px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/fanshuiRule.vue